import { createContext } from 'react';

const StackContext = createContext(null);
export default StackContext;